import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import React from 'react';

export const PolicyholderLoadingForm = () => {
	return (
		<Grid container spacing={2}>
			<Grid item xs={6}>
				<Skeleton width={'100%'} height={40} />
			</Grid>
			<Grid item xs={6}>
				<Skeleton width={'100%'} height={40} />
			</Grid>
			<Grid item xs={6}>
				<Skeleton width={'100%'} height={40} />
			</Grid>
			<Grid item xs={6}>
				<Skeleton width={'100%'} height={40} />
			</Grid>
		</Grid>
	);
};
